
class RangeSlider {
  constructor (rangeElement, valueElement) {
    this.rangeElement = rangeElement
    this.valueElement = valueElement

    // Attach a listener to "change" event
    this.rangeElement.addEventListener('input', this.updateSlider.bind(this))
  }

  // Initialize the slider
  init() {

    this.updateSlider()
  }

  generateBackground(rangeElement) {   
    if (this.rangeElement.value === this.rangeElement.getAttribute("min")) {
      return
    }

    let percentage =  (this.rangeElement.value - this.rangeElement.getAttribute("min")) / (this.rangeElement.getAttribute("max") - this.rangeElement.getAttribute("min")) * 100
    return 'background: linear-gradient(to right, #000 ' + percentage + '%, #f7f7f7 ' + percentage + '%, #f7f7f7 100%)'
  }

  updateSlider (newValue) {
    this.valueElement.innerHTML = this.rangeElement.value + " cm"
    this.rangeElement.style = this.generateBackground(this.rangeElement.value)
  }
}



theme.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = Object.assign({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = currentOptions.filter(Boolean);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = variants.find(function(variant) {
        return selectedValues.every(function(values) {
          return variant[values.index] === values.value;
        });
      });
      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },



    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },


    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();

theme.Product = (function() {
  function Product(container) {
    var $container = this.$container = $(container);
	
    this.settings = {
      productPageLoad: false,
      enableHistoryState: true,
      namespace: '.productSection'
    };
    
    this.selectors = {
      addToCart: '#AddToCart',
      productPrice: '.product-price',
      addToCartForm: "#AddToCartForm",
      priceWrapper: '.product-single__price--wrapper',
      originalSelectorId: '#ProductSelect',
      singleOptionSelector: '.short-form .single-option-selector__radio',
      radioWrapper: '.radio-wrapper',
      productWrapper: '.product-single',
    };

      
    var prodId = document.getElementById("productSection").dataset.productId;
    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + prodId).innerHTML);
    
    this.initProductVariant();
    
    if ($(".featured_images").length > 0){
      new Swiper(".featured_images",{
        grabCursor: true,
        slidesPerView: "4.5",
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        breakpoints: {
          1024: {
            slidesPerView: "2.5"
          },
        }
      });
    }    
    // NW function for  sliders
    var initProductSlider = function(prodSlideshow, direction, slides) {                                                                                                                   
      var s = new Swiper(prodSlideshow, {
        direction: direction,
        slidesPerView: slides,
        spaceBetween: 10,
        pagination: {
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
        },
      });
      return s;
    };
    var slider = null;
    var imageSliderHandler = function(){
      // swiper desktop
      var direction = "horizontal";
      var slides = 1;
      var slide;
      var sl_el = "#product-main-image";
      if (document.documentElement.clientWidth > 740){
        direction = "vertical";
        slides = 4;
        sl_el = ".thumbnail-slider";

      }
      if (slider && slider.params["direction"] != direction){
        slider.destroy();
        slider = null;
      }
      if (slider == null){
      	slider = initProductSlider(sl_el, direction, slides);
        if (direction == "horizontal"){
          slider.on('slideChange', function () {
            slide = slider.slides[slider.realIndex];
            if (slide.classList.contains("video-link")){
                start_video(slide);
            }
          });
        }
      }
    }
    function adjust_siper_slide_height(){
      if (document.documentElement.clientWidth > 740){
        $("#thumbnail-gallery .thumbnail-slider").height($("#product-main-image").height());
      }
    }
    $(window).on('resize orientationChange', function(event) {
      imageSliderHandler();
      adjust_siper_slide_height();
    });
    var start_video = function(el){
      var media_id = el.id;
      if (media_id == ""){
        media_id = el.dataset.target;
      }
      try{
        var video_el = document.getElementById(media_id+"-video")
        video_el.play();
        video_el.parentNode.classList.add("video-playing");
      }catch(e){
        console.log(e);
      }
    }
      
      $('#id_open_reviews').on("click", function(){
        $('#reviews-lightbox').show();
      });
      $('.featherlight-close').on("click", function(){
        $('.featherlight').hide();
      });
      var $medias = $('#product-main-image .img_link');
      $('.clicker-thumb').hover(function() {
        if (this.classList.contains("video-link")){
            start_video(this);
        }
        $medias.addClass("hide");
        document.getElementById(this.dataset.target).classList.remove("hide");
        $('.thumbnail').removeClass("active");  
        $(this).find(".thumbnail").addClass("active");
        return false;
      });
      adjust_siper_slide_height();
      imageSliderHandler();
      $(".video-link").on("click",function(){
        start_video(this);
      });
    const open_fit_size = document.getElementById("open_fit_size");
    if(open_fit_size){
      open_fit_size.addEventListener("click", (ev) =>{
          this.init_fit_size();
      })
    }
  }
  
  
  
  Product.prototype = Object.assign({}, Product.prototype, {
  	init_fit_size: function(){   
      
      const size_wrapper = document.querySelector("#fs_step_1 .single-option-radio");
      size_wrapper.innerHTML=""
      this.productSingleObject.variants.forEach(v=>{
        const size = v.option1;
        const sel = document.createElement("div");
        const ipt = document.createElement("input");
        ipt.type = "radio";
        ipt.id = "1_"+size;
        ipt.className="single-option-selector__radio";
        ipt.name = "fit-size";
        ipt.value = size;
        ipt.dataset.goto="2";
        sel.appendChild(ipt);
        const lbl = document.createElement("label");
        lbl.setAttribute("for", "1_"+size)
        lbl.textContent = size;
        sel.appendChild(lbl)
        /*
        <input type="radio" id="1_{{ product.id }}_{{ value }}" class="single-option-selector__radio" name="fit-size" value="{{ value }}" data-goto="2">      
        <label for="1_{{ product.id }}_{{ value }}">{{ value }}</label>
        */
        size_wrapper.appendChild(sel);
      });
      const fitSizeGuide = document.querySelector("#fit-size-lightbox")
      const skipStep = fitSizeGuide.dataset.skipstep;
      fitSizeGuide.style.display="block";
      const fs_atc = document.querySelector("#fs_atc");
      fs_atc.addEventListener("click", (event)=>{
        document.querySelector("#AddToCartForm input[value='"+fs_atc.dataset.size+"']").checked = true;
        document.querySelector("#ProductSelect").value = parseInt(fs_atc.dataset.variant_id);
        fitSizeGuide.style.display = "none";
        document.querySelector("#AddToCart").click();
      });
      const fs_soldout_btn = document.querySelector("#fs_soldout_btn");
      fs_soldout_btn.addEventListener("click", (event)=>{
        fitSizeGuide.style.display = "none";
        BIS.popup.show({variantId: parseInt(fs_soldout_btn.dataset.variant_id)})
      });
            
      function saveGoTo(radio, product_obj){
        const fs_card = radio.closest(".fs_step");
        fs_card.dataset.value= radio.value;
        fs_card.style.display = "none";
        let next_step = radio.dataset.goto;
        if (skipStep && next_step == skipStep){
          next_step = String(parseInt(next_step) + 1);
        }
        document.querySelector("#fs_step_"+next_step).style.display = "block";
        if (next_step == "7"){
          const res = document.getElementById("fit-size-result");
          const perfectSize = document.getElementById("fs_step_1").dataset.value;
          res.textContent = perfectSize;
          let found;
          product_obj.productSingleObject.variants.forEach( v =>{
            if (v.option1 == perfectSize){
              found = v;
              return
            }
          });
          if(found && found.inventory_quantity > 0){
            fs_atc.dataset.variant_id= found.id;
            fs_atc.dataset.size = perfectSize;
            document.querySelector("#fs-actions").classList.add("available");
            document.querySelector("#fs-actions").classList.remove("unavailable");
          }else{
            document.querySelector("#fs-actions").classList.add("unavailable");
            document.querySelector("#fs-actions").classList.remove("available");
            fs_soldout_btn.dataset.variant_id = found.id
          }
        }
      } 
      
      const fs_steps = fitSizeGuide.querySelectorAll(".fs_step");
      fs_steps.forEach( step => {
        step.style.display="none"
        step.addEventListener("click", (e) => {
          if (e.target.nodeName == "LABEL"){
            const rTarget = document.getElementById(e.target.getAttribute('for'));
            saveGoTo(rTarget, this);
          }
          if (e.target.nodeName == "IMG"){
            const rTarget = document.getElementById(e.target.parentNode.getAttribute('for'));
            saveGoTo(rTarget, this);
          }
          
        })
      });
      fitSizeGuide.querySelector("#fs_step_1").style.display = "block";
      const backBtns = fitSizeGuide.querySelectorAll(".goto-step");
      backBtns.forEach( btn => {
        btn.addEventListener("click", function(event){
          event.preventDefault();
          const fs_card = btn.closest(".fs_step");
          fs_card.style.display = "none";
          let prev_step = btn.dataset.goto;
          if (skipStep && prev_step == skipStep){
            prev_step = String(parseInt(prev_step) - 1);
          }
          document.querySelector("#fs_step_"+prev_step).style.display = "block";
        })
      });
      let rangeElement = document.querySelector('#height_range')
      let valueElement = document.querySelector('#height_output') 
      if (rangeElement) {
        let slider = new RangeSlider(rangeElement, valueElement)
        slider.init()
      }
    },
    initProductVariant: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new theme.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this.productPage.bind(this));
    },
    productPage: function(evt) {
      var moneyFormat = $(this.selectors.addToCartForm).data('money-format');
      var variant = evt.variant;
      if (variant) {
        // Select a valid variant if available
        if (variant.available) {
          
          // Available, enable the submit button
          $(this.selectors.addToCart).removeClass('disabled').prop('disabled', false);
        } else {
          // Sold out, disable the submit button
          $(this.selectors.addToCart).addClass('disabled').prop('disabled', true);
        }
        $(this.selectors.productPrice).html(Shopify.formatMoney(variant.price, moneyFormat)).show();

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $('.was', "#product-description").html(Shopify.formatMoney(variant.compare_at_price, moneyFormat));
        } else {
          $('.was', "#product-description").text('');
        }
		if (parseInt(variant.inventory_quantity) <= 0 && variant.inventory_management == "shopify" && variant.inventory_policy == "continue") {
          if ($(".shipping-info-sold-out").length) {
            $(".shipping-info").addClass("hide");
            $(".shipping-info-sold-out").removeClass("hide");
          }
        }else{
          if ($(".shipping-info-sold-out").length) {
            $(".shipping-info").removeClass("hide");
            $(".shipping-info-sold-out").addClass("hide");
          } 
        }

      } else {
        // 4749843005519 3er boxershorts
        if(this. productSingleObject.id != 4749843005519){
          // The variant doesn't exist, disable submit button.
          // This may be an error or notice that a specific variant is not available.
          // To only show available variants, implement linked product options:
          //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
          $(this.selectors.addToCart).addClass('disabled').prop('disabled', true);
          $(".shipping-info").removeClass("hide");
          $(".shipping-info-sold-out").addClass("hide");
        }
      }
    }
  });

  return Product;
})();

/**
 * Featherlight - ultra slim jQuery lightbox
 * Version 1.7.13 - http://noelboss.github.io/featherlight/
 *
 * Copyright 2018, Noël Raoul Bossart (http://www.noelboss.com)
 * MIT Licensed.
**/
!function(a){"use strict";function b(a,c){if(!(this instanceof b)){var d=new b(a,c);return d.open(),d}this.id=b.id++,this.setup(a,c),this.chainCallbacks(b._callbackChain)}function c(a,b){var c={};for(var d in a)d in b&&(c[d]=a[d],delete a[d]);return c}function d(a,b){var c={},d=new RegExp("^"+b+"([A-Z])(.*)");for(var e in a){var f=e.match(d);if(f){var g=(f[1]+f[2].replace(/([A-Z])/g,"-$1")).toLowerCase();c[g]=a[e]}}return c}if("undefined"==typeof a)return void("console"in window&&window.console.info("Too much lightness, Featherlight needs jQuery."));if(a.fn.jquery.match(/-ajax/))return void("console"in window&&window.console.info("Featherlight needs regular jQuery, not the slim version."));var e=[],f=function(b){return e=a.grep(e,function(a){return a!==b&&a.$instance.closest("body").length>0})},g={allow:1,allowfullscreen:1,frameborder:1,height:1,longdesc:1,marginheight:1,marginwidth:1,mozallowfullscreen:1,name:1,referrerpolicy:1,sandbox:1,scrolling:1,src:1,srcdoc:1,style:1,webkitallowfullscreen:1,width:1},h={keyup:"onKeyUp",resize:"onResize"},i=function(c){a.each(b.opened().reverse(),function(){return c.isDefaultPrevented()||!1!==this[h[c.type]](c)?void 0:(c.preventDefault(),c.stopPropagation(),!1)})},j=function(c){if(c!==b._globalHandlerInstalled){b._globalHandlerInstalled=c;var d=a.map(h,function(a,c){return c+"."+b.prototype.namespace}).join(" ");a(window)[c?"on":"off"](d,i)}};b.prototype={constructor:b,namespace:"featherlight",targetAttr:"data-featherlight",variant:null,resetCss:!1,background:null,openTrigger:"click",closeTrigger:"click",filter:null,root:"body",openSpeed:250,closeSpeed:250,closeOnClick:"background",closeOnEsc:!0,closeIcon:"&#10005;",loading:"",persist:!1,otherClose:null,beforeOpen:a.noop,beforeContent:a.noop,beforeClose:a.noop,afterOpen:a.noop,afterContent:a.noop,afterClose:a.noop,onKeyUp:a.noop,onResize:a.noop,type:null,contentFilters:["jquery","image","html","ajax","iframe","text"],setup:function(b,c){"object"!=typeof b||b instanceof a!=!1||c||(c=b,b=void 0);var d=a.extend(this,c,{target:b}),e=d.resetCss?d.namespace+"-reset":d.namespace,f=a(d.background||['<div class="'+e+"-loading "+e+'">','<div class="'+e+'-content">','<button class="'+e+"-close-icon "+d.namespace+'-close" aria-label="Close">',d.closeIcon,"</button>",'<div class="'+d.namespace+'-inner">'+d.loading+"</div>","</div>","</div>"].join("")),g="."+d.namespace+"-close"+(d.otherClose?","+d.otherClose:"");return d.$instance=f.clone().addClass(d.variant),d.$instance.on(d.closeTrigger+"."+d.namespace,function(b){if(!b.isDefaultPrevented()){var c=a(b.target);("background"===d.closeOnClick&&c.is("."+d.namespace)||"anywhere"===d.closeOnClick||c.closest(g).length)&&(d.close(b),b.preventDefault())}}),this},getContent:function(){if(this.persist!==!1&&this.$content)return this.$content;var b=this,c=this.constructor.contentFilters,d=function(a){return b.$currentTarget&&b.$currentTarget.attr(a)},e=d(b.targetAttr),f=b.target||e||"",g=c[b.type];if(!g&&f in c&&(g=c[f],f=b.target&&e),f=f||d("href")||"",!g)for(var h in c)b[h]&&(g=c[h],f=b[h]);if(!g){var i=f;if(f=null,a.each(b.contentFilters,function(){return g=c[this],g.test&&(f=g.test(i)),!f&&g.regex&&i.match&&i.match(g.regex)&&(f=i),!f}),!f)return"console"in window&&window.console.error("Featherlight: no content filter found "+(i?' for "'+i+'"':" (no target specified)")),!1}return g.process.call(b,f)},setContent:function(b){return this.$instance.removeClass(this.namespace+"-loading"),this.$instance.toggleClass(this.namespace+"-iframe",b.is("iframe")),this.$instance.find("."+this.namespace+"-inner").not(b).slice(1).remove().end().replaceWith(a.contains(this.$instance[0],b[0])?"":b),this.$content=b.addClass(this.namespace+"-inner"),this},open:function(b){var c=this;if(c.$instance.hide().appendTo(c.root),!(b&&b.isDefaultPrevented()||c.beforeOpen(b)===!1)){b&&b.preventDefault();var d=c.getContent();if(d)return e.push(c),j(!0),c.$instance.fadeIn(c.openSpeed),c.beforeContent(b),a.when(d).always(function(a){c.setContent(a),c.afterContent(b)}).then(c.$instance.promise()).done(function(){c.afterOpen(b)})}return c.$instance.detach(),a.Deferred().reject().promise()},close:function(b){var c=this,d=a.Deferred();return c.beforeClose(b)===!1?d.reject():(0===f(c).length&&j(!1),c.$instance.fadeOut(c.closeSpeed,function(){c.$instance.detach(),c.afterClose(b),d.resolve()})),d.promise()},resize:function(a,b){if(a&&b){this.$content.css("width","").css("height","");var c=Math.max(a/(this.$content.parent().width()-1),b/(this.$content.parent().height()-1));c>1&&(c=b/Math.floor(b/c),this.$content.css("width",""+a/c+"px").css("height",""+b/c+"px"))}},chainCallbacks:function(b){for(var c in b)this[c]=a.proxy(b[c],this,a.proxy(this[c],this))}},a.extend(b,{id:0,autoBind:"[data-featherlight]",defaults:b.prototype,contentFilters:{jquery:{regex:/^[#.]\w/,test:function(b){return b instanceof a&&b},process:function(b){return this.persist!==!1?a(b):a(b).clone(!0)}},image:{regex:/\.(png|jpg|jpeg|gif|tiff?|bmp|svg)(\?\S*)?$/i,process:function(b){var c=this,d=a.Deferred(),e=new Image,f=a('<img src="'+b+'" alt="" class="'+c.namespace+'-image" />');return e.onload=function(){f.naturalWidth=e.width,f.naturalHeight=e.height,d.resolve(f)},e.onerror=function(){d.reject(f)},e.src=b,d.promise()}},html:{regex:/^\s*<[\w!][^<]*>/,process:function(b){return a(b)}},ajax:{regex:/./,process:function(b){var c=a.Deferred(),d=a("<div></div>").load(b,function(a,b){"error"!==b&&c.resolve(d.contents()),c.fail()});return c.promise()}},iframe:{process:function(b){var e=new a.Deferred,f=a("<iframe/>"),h=d(this,"iframe"),i=c(h,g);return f.hide().attr("src",b).attr(i).css(h).on("load",function(){e.resolve(f.show())}).appendTo(this.$instance.find("."+this.namespace+"-content")),e.promise()}},text:{process:function(b){return a("<div>",{text:b})}}},functionAttributes:["beforeOpen","afterOpen","beforeContent","afterContent","beforeClose","afterClose"],readElementConfig:function(b,c){var d=this,e=new RegExp("^data-"+c+"-(.*)"),f={};return b&&b.attributes&&a.each(b.attributes,function(){var b=this.name.match(e);if(b){var c=this.value,g=a.camelCase(b[1]);if(a.inArray(g,d.functionAttributes)>=0)c=new Function(c);else try{c=JSON.parse(c)}catch(h){}f[g]=c}}),f},extend:function(b,c){var d=function(){this.constructor=b};return d.prototype=this.prototype,b.prototype=new d,b.__super__=this.prototype,a.extend(b,this,c),b.defaults=b.prototype,b},attach:function(b,c,d){var e=this;"object"!=typeof c||c instanceof a!=!1||d||(d=c,c=void 0),d=a.extend({},d);var f,g=d.namespace||e.defaults.namespace,h=a.extend({},e.defaults,e.readElementConfig(b[0],g),d),i=function(g){var i=a(g.currentTarget),j=a.extend({$source:b,$currentTarget:i},e.readElementConfig(b[0],h.namespace),e.readElementConfig(g.currentTarget,h.namespace),d),k=f||i.data("featherlight-persisted")||new e(c,j);"shared"===k.persist?f=k:k.persist!==!1&&i.data("featherlight-persisted",k),j.$currentTarget.blur&&j.$currentTarget.blur(),k.open(g)};return b.on(h.openTrigger+"."+h.namespace,h.filter,i),{filter:h.filter,handler:i}},current:function(){var a=this.opened();return a[a.length-1]||null},opened:function(){var b=this;return f(),a.grep(e,function(a){return a instanceof b})},close:function(a){var b=this.current();return b?b.close(a):void 0},_onReady:function(){var b=this;if(b.autoBind){var c=a(b.autoBind);c.each(function(){b.attach(a(this))}),a(document).on("click",b.autoBind,function(d){if(!d.isDefaultPrevented()){var e=a(d.currentTarget),f=c.length;if(c=c.add(e),f!==c.length){var g=b.attach(e);(!g.filter||a(d.target).parentsUntil(e,g.filter).length>0)&&g.handler(d)}}})}},_callbackChain:{onKeyUp:function(b,c){return 27===c.keyCode?(this.closeOnEsc&&a.featherlight.close(c),!1):b(c)},beforeOpen:function(b,c){return a(document.documentElement).addClass("with-featherlight"),this._previouslyActive=document.activeElement,this._$previouslyTabbable=a("a, input, select, textarea, iframe, button, iframe, [contentEditable=true]").not("[tabindex]").not(this.$instance.find("button")),this._$previouslyWithTabIndex=a("[tabindex]").not('[tabindex="-1"]'),this._previousWithTabIndices=this._$previouslyWithTabIndex.map(function(b,c){return a(c).attr("tabindex")}),this._$previouslyWithTabIndex.add(this._$previouslyTabbable).attr("tabindex",-1),document.activeElement.blur&&document.activeElement.blur(),b(c)},afterClose:function(c,d){var e=c(d),f=this;return this._$previouslyTabbable.removeAttr("tabindex"),this._$previouslyWithTabIndex.each(function(b,c){a(c).attr("tabindex",f._previousWithTabIndices[b])}),this._previouslyActive.focus(),0===b.opened().length&&a(document.documentElement).removeClass("with-featherlight"),e},onResize:function(a,b){return this.resize(this.$content.naturalWidth,this.$content.naturalHeight),a(b)},afterContent:function(a,b){var c=a(b);return this.$instance.find("[autofocus]:not([disabled])").focus(),this.onResize(b),c}}}),a.featherlight=b,a.fn.featherlight=function(a,c){return b.attach(this,a,c),this},a(document).ready(function(){b._onReady()})}(jQuery);


$('.jdgm-preview-badge').click(function(){
     $(this).parent().click();
  });
function initCTA(){
  const windowWidth = $(window).width();
  const windowHeight = $(window).height();
  const addToCartForm = document.getElementById("AddToCartForm");
  let breakPointStickyATC = 200;
  if(addToCartForm != null){
    const addToCartTop = addToCartForm.getBoundingClientRect().top;
//    breakPointStickyATC = addToCartTop - 200;
    if (windowHeight < addToCartTop){
      breakPointStickyATC =  200+(addToCartTop - windowHeight);
    }

    $(window).scroll(function() {
      // Scroll to top button
      let scrollPos = $(this).scrollTop();
      if (breakPointStickyATC > 0){
        if (windowWidth < 680 && scrollPos > breakPointStickyATC){
          if (!addToCartForm.classList.contains("fixed")){
            addToCartForm.classList.add("fixed");
          }
        }else{
          if (addToCartForm.classList.contains("fixed")){
            addToCartForm.classList.remove("fixed");
          }
        }
      }

    });
  }
}
function init_color_swatch(){
  const show_all_colors = document.getElementById("all_colors");
  if (show_all_colors){
    show_all_colors.addEventListener("click", function(e) {
      e.preventDefault();
      const ps_links = show_all_colors.parentNode.querySelectorAll("a");
      ps_links.forEach(link =>{
        link.style.display = "inline-block";
      });
      show_all_colors.style.display="none";
    })
  }
      const c_swatches = document.querySelector(".color-swatch .swatch__container");
      if (c_swatches){
        c_swatches.querySelectorAll("a").forEach(swatch_link =>{
          swatch_link.addEventListener("click",function(e) {
            e.preventDefault();
            fetch(swatch_link.href).then(function (response) {
            	return response.text();
            }).then(function (html) {
            	const doc = new DOMParser().parseFromString(html, 'text/html');
              const new_p = doc.getElementById("productSection");
              if (new_p) {
                const newColorSwatch = new_p.querySelector(".color-swatch");
                const newSwatchContainer = new_p.querySelector(".color-swatch .swatch__container");
                if (newColorSwatch && newSwatchContainer) {
                  newColorSwatch.replaceChild(c_swatches, newSwatchContainer);
                }
                const pPage = document.getElementById("shopify-section-product-template");
                pPage.innerHTML = ""
                pPage.appendChild(new_p)
              new theme.Product(pPage);
              jQuery(function($) {
                ajaxCart.init({
                  formSelector: '#AddToCartForm',
                  cartContainer: '#CartContainer',
                  addToCartSelector: '#AddToCart',
                  cartCountSelector: '.CartCount',
                  cartCostSelector: '.CartCost',
                  moneyFormat: "\u003cspan class=money\u003e{{amount}} \u0026euro;\u003c\/span\u003e",
                  onToggleCallback: function(cart) {
                }
               });
              });
              swatch_link.parentNode.querySelector(".active_color").classList.remove("active_color");
              swatch_link.classList.add("active_color");
              window.history.replaceState({path: swatch_link.href}, '', swatch_link.href);
              const accs = pPage.querySelectorAll(".accordion-tab");
              accs.forEach((acc) =>{
                acc.addEventListener("click", function(){
                  $(this).next(".accordion-content").slideToggle("fast"); 
            		$(this).parent().toggleClass("closed open"); 
                });
              })
              }            
            }).catch(function (err) {
            	console.warn('Something went wrong.', err);
            });
          })
        })
      }
    }

$(document).ready(function() {
  var productSection = document.getElementById("productSection");
  new theme.Product(productSection);
  init_color_swatch();
  
  //initCTA();
               
  var $container = $(".product-recommendations");
    var productId = $container.data('productId');
    var limit = $container.data('limit');
    var productRecommendationsUrlAndContainerClass =
      '/recommendations/products?&section_id=product-recommendations&limit=' + limit + '&product_id=' + productId;
    var request = new XMLHttpRequest();
  	request.open("GET", productRecommendationsUrlAndContainerClass);
  	request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      $container.parent().html(container);
      // create slider
      new Swiper('.recommendations-slider',{
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          slidesPerView: 5,
          spaceBetween: 50,
          /*pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },*/
          breakpoints: {
            1024: {
              slidesPerView: 4,
              spaceBetween: 40,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 10,
            }
          },
          watchOverflow: true
      });
    }
  };
  request.send();
});
